export const AUTH_SESSION_CHANGED_KEY = "auth_session_changed_at";
const AUTHENTICATION_STORAGE_KEYS = [
    "token",
    "tokenHCM",
    "tokenSamples",
    "user",
    "userName",
    "user_permissions",
    "specialties",
    "perfil",
    "perfil_id",
    "role_id",
    "stablishment",
    "stablishmentName",
    "deis_codem",
    "survey_answered",
    "allow_print_attention_histories",
    "allow_reverse_state_citation",
    "allow_citation_unscheduled",
    "allow_delete_recipe",
    "allow_delete_last_dispatch",
];
function normalizeRut(rut) {
    if (rut === null || rut === undefined)
        return "";
    return String(rut)
        .replace(/[.\s-]/g, "")
        .toUpperCase();
}
function getStoredAuthenticationUser() {
    const storedUser = window.localStorage.getItem("user");
    if (!storedUser)
        return null;
    try {
        const user = JSON.parse(storedUser);
        return user && typeof user === "object" ? user : null;
    }
    catch (error) {
        return null;
    }
}
export function requiresSessionReplacement(nextUser) {
    if (!window.localStorage.getItem("token"))
        return false;
    const currentUser = getStoredAuthenticationUser();
    if (!currentUser || !nextUser)
        return true;
    if (currentUser.id !== null && currentUser.id !== undefined && nextUser.id !== null && nextUser.id !== undefined) {
        return String(currentUser.id) !== String(nextUser.id);
    }
    const currentRut = normalizeRut(currentUser.rut);
    const nextRut = normalizeRut(nextUser.rut);
    if (currentRut && nextRut) {
        return currentRut !== nextRut;
    }
    return true;
}
export function clearAuthenticationData() {
    AUTHENTICATION_STORAGE_KEYS.forEach((key) => window.localStorage.removeItem(key));
}
export function notifyAuthenticationChange() {
    window.localStorage.setItem(AUTH_SESSION_CHANGED_KEY, Date.now().toString());
}
export function clearAndNotifyAuthenticationChange() {
    clearAuthenticationData();
    notifyAuthenticationChange();
}
